<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportIncomings"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterSuppliers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Supplier " id="filter-" size="sm" :model.sync="filter.filterSupplier" @input="getFilterSuppliers" @focus="getFilterSuppliers" />
						<app-input-combobox-autocomplete :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" @input="getFilterParts" @focus="getFilterParts" />
						<app-input-textbox id="fieldset-filter-purchase-order-number" label-cols-sm="4" label-cols-lg="3" label="Purchase Order Number " label-for="filter-filter-purchase-order-number" size="sm" :model.sync="filter.filterPurchaseOrderNumber" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range  id="fieldset-filter-part-good-receipt-date" label-cols-sm="4" label-cols-lg="3" label="Part Good Receipt Date " size="sm" :modelFrom.sync="filter.filterPartGoodReceiptDateFrom" :modelTo.sync="filter.filterPartGoodReceiptDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
						<app-input-textbox id="fieldset-filter-part-name" label-cols-sm="4" label-cols-lg="3" label="Part Name " label-for="filter-filter-part-name" size="sm" :model.sync="filter.filterPartName" />
					</b-col>
					<b-col cols="12" lg="6">
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportIncomings"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Incoming</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportincoming" :class="'table-action ' + (isStacked ? '' : 'table-index')" 
					head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportIncomings" :fields="fields" :busy="isDataLoading" 
					:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass"
					>
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportIncomings.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Tanggal" class="table-filter">
							<!-- <b-form-input id="input-gr-date-table" @input="getReportIncomingsWithoutLoading" v-model="filter.grDate" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportIncomingsWithoutLoading" id="fieldset-filter-part-good-receipt-date" size="sm" :modelFrom.sync="filter.filterPartGoodReceiptDateFrom" :modelTo.sync="filter.filterPartGoodReceiptDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="No Surat Jalan" class="table-filter">
							<!-- <b-form-input id="input-surat-jalan-table" @input="getReportIncomingsWithoutLoading" v-model="filter.suratJalan" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="No PO" class="table-filter">
							<b-form-input id="input-purchase-order-number-table" @input="getReportIncomingsWithoutLoading" v-model="filter.filterPurchaseOrderNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="No Part" class="table-filter">
							<!-- <b-form-input id="input-part-number-table" @input="getReportIncomingsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" @change="getReportIncomingsWithoutLoading" @input="getFilterParts" @focus="getFilterParts" />
						</b-th>
						<b-th stacked-heading="Nama Part / Spesifikasi" class="table-filter">
							<b-form-input id="input-part-specification-table" @input="getReportIncomingsWithoutLoading" v-model="filter.filterPartName" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Case Number" class="table-filter">
							<!-- <b-form-input id="input-supplier-case-number-table" @input="getReportIncomingsWithoutLoading" v-model="filter.supplierCaseNumber" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Jumlah Actual Delivery" class="table-filter">
							<!-- <b-form-input id="input-qty-actual-table" @input="getReportIncomingsWithoutLoading" v-model="filter.qtyActual" size="sm"></b-form-input> -->
						</b-th>
						<b-th></b-th>
						<b-th stacked-heading="UoM" class="table-filter">
							<!-- <b-form-input id="input-uom-table" @input="getReportIncomingsWithoutLoading" v-model="filter.uom" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Supplier" class="table-filter">
							<!-- <b-form-input id="input-supplier-code-table" @input="getReportIncomingsWithoutLoading" v-model="filter.supplierCode" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete :options="filterSuppliers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Supplier " id="filter-" size="sm" :model.sync="filter.filterSupplier" @change="getReportIncomingsWithoutLoading" @input="getFilterSuppliers" @focus="getFilterSuppliers" />
						</b-th>
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Pelanggan" class="table-filter">
							<!-- <b-form-input id="input-customer-code-table" @input="getReportIncomingsWithoutLoading" v-model="filter.customerCode" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @change="getReportIncomingsWithoutLoading" @input="getFilterCustomers" @focus="getFilterCustomers" />
						</b-th>
						<b-th stacked-heading="Remarks" class="table-filter">
							<!-- <b-form-input id="input-remark-table" @input="getReportIncomingsWithoutLoading" v-model="filter.remark" size="sm"></b-form-input> -->
						</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					
					<template v-slot:cell(grDate)="row">
						{{ row.item.grDate | moment("DD-MMM-YYYY") }}
					</template>

					<template #bottom-row>
						<b-th colspan="6"></b-th>
						<b-th>Subtotal</b-th>
						<b-th>{{ Number(totalSum).toLocaleString() }}</b-th>
						<b-th colspan="6"></b-th>
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-purchase-order-number" label-cols-lg="12"  label="No PO" label-for="input-purchase-order-number" size="sm" :model.sync="row.item.purchaseOrderNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="No Part" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-specification" label-cols-lg="12"  label="Nama Part / Spesifikasi" label-for="input-part-specification" size="sm" :model.sync="row.item.partSpecification"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-supplier-case-number" label-cols-lg="12"  label="Supplier Case Number" label-for="input-supplier-case-number" size="sm" :model.sync="row.item.supplierCaseNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-jumlah-actual-pcs" label-cols-lg="12"  label="Jumlah Actual Pcs" label-for="input-jumlah-actual-pcs" size="sm" :model.sync="row.item.jumlahActualPcs"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-jumlah-actual-kg" label-cols-lg="12"  label="Jumlah Actual Kg" label-for="input-jumlah-actual-kg" size="sm" :model.sync="row.item.jumlahActualKg"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-uom" label-cols-lg="12"  label="UoM" label-for="input-uom" size="sm" :model.sync="row.item.uom"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-supplier-code" label-cols-lg="12"  label="Supplier" label-for="input-supplier-code" size="sm" :model.sync="row.item.supplierCode"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-case-number" label-cols-lg="12"  label="Case Number" label-for="input-case-number" size="sm" :model.sync="row.item.caseNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-gr-number" label-cols-lg="12"  label="GR Number" label-for="input-gr-number" size="sm" :model.sync="row.item.grNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-customer-name" label-cols-lg="12"  label="Pelanggan" label-for="input-customer-name" size="sm" :model.sync="row.item.customerName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-remark" label-cols-lg="12"  label="Remarks" label-for="input-remark" size="sm" :model.sync="row.item.remark"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportIncomingsPaging != null ? reportIncomingsPaging.dataCount : 0)"
											  :per-page="(reportIncomingsPaging != null ? reportIncomingsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportincoming.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportincoming.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
		padding-right: 0 !important;
    }
	::v-deep #table-list-reportincoming.b-table.b-table-stacked > tbody > tr > th.th-front-action  {
		padding-right: 0 !important;
    }
</style>
<script>
import ReportIncoming from '@/models/ReportIncoming/ReportIncoming';
import ReportIncomingList from '@/models/ReportIncoming/ReportIncomingList';
import ReportIncomingFilter from '@/filters/ReportIncoming/ReportIncomingFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportIncoming, 
		ReportIncomingList, 
		ReportIncomingFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-front-action d-stack-none"}},
				{"grDate": {}, "class" : "th-gr-date first-child", "label" : "Tanggal", key: 'grDate', }, 
				{"suratJalan": {}, "class" : "th-surat-jalan", "label" : "No Surat Jalan", key: 'suratJalan', }, 
				{"purchaseOrderNumber": {}, "class" : "th-purchase-order-number last-child", "label" : "No PO", key: 'purchaseOrderNumber', }, 
				{"partNumber": {}, "class" : "th-part-number d-stack-none", "label" : "No Part", key: 'partNumber', }, 
				{"partSpecification": {}, "class" : "th-part-specification d-stack-none", "label" : "Nama Part / Spesifikasi", key: 'partSpecification', }, 
				{"supplierCaseNumber": {}, "class" : "th-supplier-case-number d-stack-none", "label" : "Supplier Case Number", key: 'supplierCaseNumber', }, 
				{"jumlahActualPcs": {}, "class" : "th-jumlah-actual-pcs d-stack-none", "label" : "Jumlah Actual Pcs", key: 'jumlahActualPcs', }, 
				{"jumlahActualKg": {}, "class" : "th-jumlah-actual-kg d-stack-none", "label" : "Jumlah Actual Kg", key: 'jumlahActualKg', }, 
				{"uom": {}, "class" : "th-uom d-stack-none", "label" : "UoM Invent", key: 'uom', }, 
				{"supplierCode": {}, "class" : "th-supplier-code d-stack-none", "label" : "Supplier", key: 'supplierCode', }, 
				{"caseNumber": {}, "class" : "th-case-number d-stack-none", "label" : "Case Number", key: 'caseNumber', }, 
				{"grNumber": {}, "class" : "th-supplier-gr-number d-stack-none", "label" : "GR Number", key: 'grNumber', }, 
				{"customerName": {}, "class" : "th-customer-name d-stack-none", "label" : "Pelanggan", key: 'customerName', }, 
				{"remark": {}, "class" : "th-remark d-stack-none", "label" : "Remarks", key: 'remark', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportIncomings: [],
			reportIncomingsPaging: {},
			filterSuppliers : [],
			filterParts : [],
			filterCustomers : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			totalSum: 0,
		}
	},	methods : {
		getReportIncomings : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			let _this = this;

			ReportIncoming.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportIncomings = result.data
					this.reportIncomingsPaging = result
					ReportIncoming.getSum(this, this.filter, this.sortingBy)
					.then(resultsum => {
						if(resultsum != null) {
							_this.totalSum = resultsum;
						}
					})
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportIncomingsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			let _this = this;

			ReportIncoming.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportIncomings = result.data
					this.reportIncomingsPaging = result
					ReportIncoming.getSum(this, this.filter, this.sortingBy)
					.then(resultsum => {
						if(resultsum != null) {
							_this.totalSum = resultsum;
						}
					})
				}
			})
			.catch(error => {});
		},
		getFilterSuppliers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportIncoming.getListCustomUrl(this,'getlistfiltersupplier' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterSuppliers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterParts : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportIncoming.getListCustomUrl(this,'getlistfilterpart' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterParts = result.data
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportIncoming.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportIncomingFilter();
			this.getReportIncomings();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportIncomings();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportIncoming.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportIncoming.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportIncoming.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportIncoming.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportIncomings();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportIncoming.deleteMultipleData(this).then(result => {
					this.getReportIncomings();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportIncomingParent = document.getElementById('table-list-reportincoming').parentNode;
			tableReportIncomingParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportIncomingParent.scrollWidth - tableReportIncomingParent.offsetWidth) == Math.ceil(tableReportIncomingParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportIncomingParent = document.getElementById('table-list-reportincoming').parentNode;
			tableReportIncomingParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportIncomingParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportIncomingFilter();
		this.getFilterSuppliers()
		this.getFilterParts()
		this.getFilterCustomers()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Incoming"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportIncomings();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportIncomings();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportIncomings();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportIncomings();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportIncomings();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportIncoming.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportincomingindex") {
					this.getReportIncomingsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_incoming").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
